import { DogLogger } from './doglogger/doglogger.js';

export const packageLogger = new DogLogger('ndoc');

export default packageLogger;
